<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ $t('add_flaw_modal.new_flaw') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body flawmodal">
					<FlawView
						@goBack="cancel"
						@saveState="saveState"
						@flaw-added="flawAdded"
						@flaw-fixed="setFixed"
						@continueWithoutAdding="continueWithoutAdding"
						:round="round"
						:ctx="ctx"
						@service-info-queued="$emit('service-info-queued')"
					/>
				</section>
			</div>
		</div>
	</div>
</template>
<script>
import FlawView from '../FlawView.vue';
export default {
	components: {
		FlawView
	},
	props: {
		ctx: { type: Object, required: true },
		round: { type: Object, required: true }
	},
	methods: {
		cancel() {
			this.$emit('cancel');
		},
		flawAdded(item) {
			this.$emit('flaw-added', item);
		},
		saveState(payload) {
			this.$emit('saveState', payload);
		},
		setFixed(item) {
			this.$emit('flaw-fixed', item);
		},
		continueWithoutAdding(item) {
			this.$emit('continueWithoutAdding', item);
		}
	}
};
</script>
<style lang="scss">
.flawmodal {
  .title {
    display: none !important;
  }

  .field.check {
    max-width: 90px !important;
  }

  .main-view {
    padding-top: 0px !important;
  }

  .label {
    color: #23282d !important;
  }
}
</style>
